class WsCards extends HTMLElement {
    constructor() {
        super();
        this.cards = this.querySelectorAll('.ws-card');
        this.intervalTime = parseInt(this.dataset.autoplayInterval, 10);
        this.intervalId = null;
        this.currentIndex = 0;
        this.isPaused = false;

        if (this.cards.length <= 1 || !this.intervalTime) return;
        this.init();
    }

    init() {
        this.startAutoplay();
        this.addEventListeners();
    }

    startAutoplay() {
        if (this.isPaused || this.intervalId) return;
        this.intervalId = setInterval(() => this.cycleActiveCard(), this.intervalTime);
    }

    stopAutoplay() {
        clearInterval(this.intervalId);
        this.intervalId = null;
    }

    cycleActiveCard() {
        this.setActiveCard(this.currentIndex, false);
        this.currentIndex = (this.currentIndex + 1) % this.cards.length;
        this.setActiveCard(this.currentIndex, true);
    }

    setActiveCard(index, isActive) {
        const card = this.cards[index];
        if (card) {
            card.classList.toggle('is-active', isActive);
        }
    }

    addEventListeners() {
        const grid = this.querySelector('.ws-cards__content');

        this.cards.forEach((card, index) => {
            card.addEventListener('mouseenter', () => {
                this.isPaused = true;
                this.stopAutoplay();
                this.cards.forEach(c => c.classList.remove('is-active'));
                card.classList.add('is-active');
                this.currentIndex = index;
            });
        });

        if (grid) {
            grid.addEventListener('mouseleave', () => {
                this.isPaused = false;
                this.startAutoplay();
            });
        }
    }
    
    disconnectedCallback() {
        if (this.intervalId) {
            this.stopAutoplay();
        }
    }
}

customElements.define('ws-cards', WsCards);